import React, { memo, useMemo, useCallback } from 'react';
import IconMC from '../../../components/IconMC';
import ImageMC from '../../../components/ImageMC';
import { useTraceUpdate } from '../../../hooks/shared/useDebugRenders';

/**
 * AttachedProductMC - Componente para mostrar un producto adjunto a un mensaje.
 */
const AttachedProductMC = memo(({ product, onRemoveProduct }) => {
  // Debug: rastreo de renders y cambios de props
  useTraceUpdate('AttachedProductMC', {
    productId: product?.id,
    imagesCount: product?.image_urls?.length,
    onRemoveProduct
  });

  /**
   * productImages - Imágenes del producto.
   */
  const productImages = useMemo(() => {
    if (!product) return [];
    // Mantener el índice original para poder eliminar correctamente
    return product.image_urls
      .map((image, originalIndex) => ({ ...image, originalIndex }))
      .filter((image) => image.display);
  }, [product]);

  // Memoizar función de renderizado para evitar recreación
  const renderProductImage = useCallback((image) => (
    <div key={`product-${image.originalIndex}`} className="tw-relative tw-bg-transparent">
      <div className="tw-absolute tw-top-[-8px] tw-right-[-8px] tw-z-10 tw-bg-transparent">
        <IconMC
          name="close-circle-fill"
          size="xl"
          className="tw-text-gray-400 hover:tw-text-red-500 tw-bg-white tw-rounded-full"
          onClick={() => onRemoveProduct(image.originalIndex)}
        />
      </div>
      <ImageMC
        data={{ contentMediaUrl: image.url }}
        alt="Product Image"
        className="!tw-h-20 !tw-w-20 tw-object-cover tw-rounded-lg tw-border tw-border-gray-200"
      />
    </div>
  ), [onRemoveProduct]);

  if (!product) return null;

  return (
    <div className="tw-flex tw-flex-wrap tw-p-2 tw-bg-transparent">
      {productImages.map(renderProductImage)}
    </div>
  );
});

AttachedProductMC.displayName = 'AttachedProductMC';

export default AttachedProductMC;
